import React, { ReactNode } from 'react'
import { SectionHeaderWithSeeAll } from 'shared/components/section-header'
import VideoScrollCarousel from 'shared/components/video-preview-thumbnail/scroll-carousel/trending'
import styled from 'styled-components'

const Container = styled.div`
    margin-bottom: 20px;
`
type Props = {
    icon?: ReactNode
    isHomepage?: boolean
}

const TodaysVideos = ({ icon, isHomepage }: Props) => {
    return (
        <Container>
            <SectionHeaderWithSeeAll
                label="Videos"
                seeAllLabel={`All Videos`}
                icon={icon}
                url="/videos"
                isHistoryPush
                isHomepage={isHomepage}
            />
            <VideoScrollCarousel width={160} previewLabelPadding={6} />
        </Container>
    )
}

export default TodaysVideos
